import React from "react";
import "./App.css";
import NavBar from "./components/NavBar";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Countries from "./pages/Countries";
import Favorites from "./pages/Favorites";
import CountryDetail from "./pages/CountryDetail";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div>
      <NavBar />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/countries" element={<Countries />}></Route>
          <Route path="/countries/:name" element={<CountryDetail />}></Route>
          <Route path="/favorites" element={<Favorites />}></Route>
          </Routes>
          
      </div>
      <Footer/>
    </div>
  );
}
